(() => {
  function readJson(selector) {
    const el = document.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function init() {
    const bar = document.querySelector('[data-kg-sticky-bar]');
    if (!bar) return;

    // Prevent binding twice (theme editor reloads sections)
    if (bar.dataset.kgInit === '1') return;
    bar.dataset.kgInit = '1';

    const cfg = readJson('[data-kg-sticky-config]') || {};
    const product = readJson('[data-kg-product-json]');

    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
      console.warn('[KG Sticky Bar] Missing product JSON');
      return;
    }

    const itemsWrap = bar.querySelector('[data-kg-items]');
    const priceEl = bar.querySelector('[data-kg-price]');

    function getSelectedVariantId() {
      // Dawn uses <product-form> with a hidden input[name="id"]
      const idInput =
        document.querySelector('product-form input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return idInput?.value ? Number(idInput.value) : null;
    }

    function formatMoneyFt(cents) {
      // basic HU formatting; if you want exact Shopify money format later, we can improve it
      return (Number(cents) / 100).toLocaleString('hu-HU') + ' Ft';
    }

    function render(variant) {
    if (!variant) return;

    /** UNCOMMENT IF PRICE SHOULD CHANGE UPON CHANGING VARIANT */
    /*
    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoneyFt(variant.price);
    }
    */
    if (priceEl && product.price_min != null) {
      priceEl.textContent = formatMoneyFt(product.price_min);
    }
    const opts = variant.options || [];

    // Option order: [0] length, [1] color
    const items = [
      { key: 'length', label: cfg.lengthLabel || 'Selected length', value: opts[0] },
      { key: 'color',  label: cfg.colorLabel  || 'Selected color',  value: opts[1] },
    ].filter(x => x.value);

    if (itemsWrap) {
      itemsWrap.innerHTML = items
        .map(x =>
          `<p class="product-material kg-opt kg-opt--${x.key}" data-kg-opt="${x.key}">
            ${x.label}: ${x.value}
          </p>`
        )
        .join('');
    }
  }



    function update() {
      const vid = getSelectedVariantId();
      const v = product.variants.find(x => Number(x.id) === Number(vid)) || product.variants[0];
      render(v);
    }

    function getHeaderHeightPx() {
      const v = getComputedStyle(document.documentElement)
        .getPropertyValue('--header-height')
        .trim();
      const px = parseFloat(v);
      return Number.isFinite(px) ? px : 0;
    }

    function setupHideOnCanvas() {
      const triggerEl = document.querySelector('.kg-canvas-abs-wrapper');
      if (!triggerEl) return;
      if (!window.gsap || !window.ScrollTrigger) return;

      const headerH = getHeaderHeightPx();
      const extra = -120;

      ScrollTrigger.create({
        trigger: triggerEl,
        start: `top top+=${headerH + extra}`,
        onEnter: () => bar.classList.add('is-hidden'),
        onLeaveBack: () => bar.classList.remove('is-hidden'),
      });
    }

    setupHideOnCanvas();


    // Initial paint
    update();

    // Dawn variant picker events
    const picker = document.querySelector('variant-selects, variant-radios');

    if (picker) {
      picker.addEventListener('variantChange', (e) => {
        // Some Dawn versions pass the variant directly
        if (e?.detail?.variant) render(e.detail.variant);
        else update();
      });

      picker.addEventListener('change', update);
    }

    // fallback for any input change in product form
    document.addEventListener('change', (e) => {
      if (e.target && e.target.closest('product-form, form[action*="/cart/add"]')) update();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
